import React from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import CustomField from "@mapmycustomers/shared/types/customField/CustomField";

import { getCustomFieldDataTypeDisplayName, getCustomFieldDataTypeImage } from "@app/util/ui";

import styles from "./CustomFieldTypeCell.module.scss";

interface Props {
  isCalculated?: boolean;
  type: CustomField["dataType"];
}

const CustomFieldTypeCell: React.FC<Props> = ({ isCalculated, type }) => {
  const intl = useIntl();

  return (
    <Row align="middle">
      <Col className={styles.imageContainer}>
        <img alt={type} src={getCustomFieldDataTypeImage(type)} />
      </Col>
      <Col className={styles.textContainer}>
        {isCalculated
          ? intl.formatMessage(
              {
                id: "settings.customFields.type.isCalculated",
                defaultMessage: "{type} (Calculated)",
                description: "Settings Custom field - custom field type - is calculated",
              },
              { type: getCustomFieldDataTypeDisplayName(intl, type) }
            )
          : getCustomFieldDataTypeDisplayName(intl, type)}
      </Col>
    </Row>
  );
};

export default CustomFieldTypeCell;
